import React, { useState, useEffect } from 'react'
import parse from 'html-react-parser'

import External from '@icons/External.jsx'

import { getPageById } from '@api/shopify'

const Expert = ({ profile1, profile2 }) => {
    const [expert1, setExpert1] = useState({
        name: '',
        bio: '',
        image: 'https://cdn.shopify.com/s/files/1/2338/2917/files/Profile_avatar_placeholder_large_ab9b57d0-b213-4961-ab73-95195196e796.png?v=1688585226',
        imageAlt: 'profile image',
        handle: '',
        url: '',
    })

    const [expert2, setExpert2] = useState(null)

    let page1Id
    let page2Id

    if (profile1) {
        page1Id = profile1
            .replace('OnlineStore', '')
            .replace(/['"]+/g, '')
            .replace(/[\])}[{(]/g, '')
            .toString()
    }

    if (profile2) {
        page2Id = profile2
            .replace('OnlineStore', '')
            .replace(/['"]+/g, '')
            .replace(/[\])}[{(]/g, '')
            .toString()
    }

    useEffect(() => {
        if (page1Id) {
            let identifiers = [
                {
                    namespace: 'custom_fields',
                    key: 'default_image',
                },
                {
                    namespace: 'custom_fields',
                    key: 'default_image_alt_text',
                },
            ]

            let id = {
                id: page1Id,
            }

            getPageById(page1Id, identifiers).then((expertData) => {
                if (expertData) {
                    const firstProfile = expertData.data.page
                    const metafields = firstProfile.metafields
                    const defaultImage = metafields.find(
                        (m) => m.key === 'default_image'
                    ).value
                    const defaultImageAlt = metafields.find(
                        (m) => m.key === 'default_image_alt_text'
                    ).value

                    setExpert1({
                        name: firstProfile.title || '',
                        bio: firstProfile.body || '',
                        image: defaultImage,
                        imageAlt: defaultImageAlt,
                        handle: firstProfile.handle || '',
                        url: firstProfile.onlineStoreUrl || '',
                    })
                }
            })
        }
    }, [])

    return (
        <div className="expert-outer p-12 bg-beige mt-12">
            <div className="expert-inner flex flex-col">
                <h2 className="text-xs uppercase tracking-wider mb-3">
                    Meet Your Expert
                </h2>
                <div className="expert-content-wrap flex gap-x-12 flex-wrap md:flex-nowrap">
                    <div className="expert-image w-full md:w-1/2 xl:w-1/4 mb-3 aspect-square">
                        <img src={expert1.image} alt={expert1.imageAlt} />
                    </div>
                    <div className="expert-content w-full md:w-1/2 xl:w-3/4">
                        <h2 className="expert-name text-2xl mb-3">
                            {expert1.name}
                        </h2>
                        <div className="expert-bio font-normal pr-12 prose !max-w-full">
                            {parse(expert1.bio)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Expert
